import React from 'react';
import { motion } from 'framer-motion';
export function StatsRow() {
  return <section className="relative bg-[#1A1A1A] py-16 border-b border-[#252525]" data-id="element-315">
      {/* Heavy timber texture */}
      <div className="absolute inset-0 texture-timber opacity-40" data-id="element-316" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-317">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center" data-id="element-318">
          <span className="text-3xl md:text-4xl font-serif font-bold text-[#F5F3F0] mb-2" data-id="element-319">
            45+ Years
          </span>
          <span className="text-sm uppercase tracking-widest text-[#A07656] font-medium" data-id="element-320">
            Combined Experience
          </span>
        </motion.div>
      </div>
    </section>;
}